 
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const StudentPage = () => {
    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col md={8} lg={6}>
                    <Card className="text-center shadow">
                        <Card.Header className="bg-primary text-white">
                            <h3><i className="bi bi-calendar-event me-2"></i>Interview Portal</h3>
                        </Card.Header>
                        <Card.Body className="py-5">
                            <div className="mb-4">
                                <i className="bi bi-envelope-check" style={{ fontSize: '4rem', color: '#6c757d' }}></i>
                            </div>
                            <h4 className="mb-3">Check Your Email</h4>
                            <p className="text-muted mb-4">
                                We've sent you an invitation email with a secure link to select your interview slot.
                                Please check your inbox and click on the "Select Interview Slot" button.
                            </p>
                            <div className="alert alert-info">
                                <i className="bi bi-info-circle me-2"></i>
                                <strong>Can't find the email?</strong> Check your spam folder or contact HR for assistance.
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default StudentPage;
